import * as Yup from "yup";
// import moment from 'moment';

const visaRegEx = /^((3\d{14})|([456]\d{15}))$/;
const cvvRegEx = /^(3\d{3}$)|([456]\d{2})$/;
const emailRegEx =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const phoneRegEx =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const memberWebsitePasswordRegEx =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/;

const requiredFieldErrorMsg = "Field is Required";

export const shippingFormSchema = Yup.object().shape({
  firstName: Yup.string().required(requiredFieldErrorMsg),
  lastName: Yup.string().required(requiredFieldErrorMsg),
  country: Yup.string().required(requiredFieldErrorMsg),
  address1: Yup.string().required(requiredFieldErrorMsg),
  city: Yup.string().required(requiredFieldErrorMsg),
  postalCode: Yup.string().required(requiredFieldErrorMsg),
  address2: Yup.string(),
  phone: Yup.string()
    .required(requiredFieldErrorMsg)
    .matches(phoneRegEx, "Invalid format"),
  email: Yup.string()
    .required(requiredFieldErrorMsg)
    .matches(emailRegEx, "Invalid format"),
  ShipToFirstName: Yup.string().required(requiredFieldErrorMsg),
  ShipToLastName: Yup.string().required(requiredFieldErrorMsg),
  ShipToCountry: Yup.string().required(requiredFieldErrorMsg),
  ShipToAddress1: Yup.string().required(requiredFieldErrorMsg),
  ShipToCity: Yup.string().required(requiredFieldErrorMsg),
  ShipToPostalCode: Yup.string().required(requiredFieldErrorMsg),
  ShipToAddress2: Yup.string(),
  ShipToPhone: Yup.string()
    .required(requiredFieldErrorMsg)
    .matches(phoneRegEx, "Invalid format"),
  ShipToEmail: Yup.string()
    .required(requiredFieldErrorMsg)
    .matches(emailRegEx, "Invalid format"),
});

export const cardFormSchema = Yup.object().shape({
  cardholder: Yup.string().required(requiredFieldErrorMsg),
  cardNumber: Yup.string()
    .required(requiredFieldErrorMsg)
    .matches(visaRegEx, "Invalid card number"),
  expMonth: Yup.string().required(requiredFieldErrorMsg),
  expYear: Yup.string().required(requiredFieldErrorMsg),
  cvv: Yup.string()
    .required(requiredFieldErrorMsg)
    .test("len", "Invalid CVV", (val, { parent }) =>
      val
        ? (val.length === 3 &&
            ["4", "5", "6"].includes(parent.cardNumber?.charAt(0))) ||
          (val.length === 4 && parent.cardNumber?.startsWith("3"))
        : false
    ),
});
